export const IMAGES = {
  heroFarm: "https://images.unsplash.com/photo-1677137263170-c8fc6406719b?crop=entropy&cs=srgb&fm=jpg&q=85",
  heroSecondary: "https://images.unsplash.com/photo-1677137264354-e8c011fe0413?crop=entropy&cs=srgb&fm=jpg&q=85",
  valleyAerial: "https://images.unsplash.com/photo-1777826332766-8139847b9ede?crop=entropy&cs=srgb&fm=jpg&q=85",
  silosMountains: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/urzfrp0b_6b9170a3-e476-4377-b695-798ba17f52c4.png",
  solarInstaller: "https://images.unsplash.com/photo-1668097613572-40b7c11c8727?crop=entropy&cs=srgb&fm=jpg&q=85",
  solarEngineer: "https://images.unsplash.com/photo-1726221062299-88f27b653c59?crop=entropy&cs=srgb&fm=jpg&q=85",
  windTurbine: "https://images.unsplash.com/photo-1548613053-22087dd8edb8?crop=entropy&cs=srgb&fm=jpg&q=85",
  windField: "https://images.unsplash.com/photo-1675116731363-c17d957f3444?crop=entropy&cs=srgb&fm=jpg&q=85",
  batteryRack: "https://images.unsplash.com/photo-1742899273038-67ff67477663?crop=entropy&cs=srgb&fm=jpg&q=85",
  batteryCabinet: "https://images.pexels.com/photos/37929911/pexels-photo-37929911.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  hydrogenTanks: "https://images.unsplash.com/photo-1695800293626-c71dffa08164?crop=entropy&cs=srgb&fm=jpg&q=85",
  hydrogenAerial: "https://images.unsplash.com/photo-1673208769691-e74104d853fd?crop=entropy&cs=srgb&fm=jpg&q=85",
  greenhouse: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/g4l5heto_8b615f93-95d8-4182-bb4d-26b10c50b4c8.png",
  greenhouse2: "https://images.unsplash.com/photo-1508855898412-54387cfbb044?crop=entropy&cs=srgb&fm=jpg&q=85",
  vineyard: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/rxunk6t8_910bfbae-5eca-4828-b619-3d9852044aee.png",
  vineyardField: "https://images.unsplash.com/photo-1732159622597-aefade3499a3?crop=entropy&cs=srgb&fm=jpg&q=85",
  dairyFields: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/4qdd8xnj_098f58b8-5b8f-41be-be07-bf60e81b0a79.png",
  barnAisle: "https://images.unsplash.com/photo-1545468259-3061e564cf56?crop=entropy&cs=srgb&fm=jpg&q=85",
  founderPortrait: "https://images.unsplash.com/photo-1770822662831-c361f15790ea?crop=entropy&cs=srgb&fm=jpg&q=85",
  founderContext: "https://images.unsplash.com/photo-1748348389780-3eb3ce44ac65?crop=entropy&cs=srgb&fm=jpg&q=85",
  whyHybridImage: "https://images.unsplash.com/photo-1785269110518-d47b14c162e4?crop=entropy&cs=srgb&fm=jpg&q=85",
  pauseImage: "https://images.unsplash.com/photo-1780728955928-2d5542bdf0cb?crop=entropy&cs=srgb&fm=jpg&q=85",
  controlRoom: "https://images.unsplash.com/photo-1780299511230-099abe21bf38?crop=entropy&cs=srgb&fm=jpg&q=85",
  powerLines: "https://images.unsplash.com/photo-1721498273717-7a152d3ec13e?crop=entropy&cs=srgb&fm=jpg&q=85",
  substation: "https://images.pexels.com/photos/33041841/pexels-photo-33041841.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  benefitsInfrastructure: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/qymp9ao5_2w0m8v7r_b043482d-ae0f-4064-96c1-2be8f0b2dc6d.png",
  coldStorage: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/y0ay5b02_0c7d1994-2829-420b-9c68-08a916368789.png",
  grainProcessing: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/7k26dn9n_022cefc0-d095-46e1-a70b-4f4998708ef5.png",
  irrigationPumpStation: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/3m9w2w1b_27f523cd-8bf8-4b0f-91f7-878f0265a7b3.png",
  farmValleyGreenhouses: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/y87nhtr9_fce356be-0ece-4379-a1b8-11dff1626bfd.png",
  energyInfrastructureField: "https://images.unsplash.com/photo-1787523628700-9a336bce95ad?crop=entropy&cs=srgb&fm=jpg&q=85",
  farmSolarBatteryGenerator: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/picka5mu_8617343b-4970-4348-86b2-b36ccde3aff2.png",
  hillsideSolarArray: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/hw5c0z8p_a96aac2d-3186-429a-a0da-d10155181860.png",
  technologyHero: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/cmqydtbw_a7312ba9-92ac-4d8f-b93c-5587214ec8bd.png",
  systemIntegrationPhoto: "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/i5vgkrjf_66f35a36-3593-4e96-bc2c-0d088ae32533.png",
};

export const PRODUCT_PLATFORM = [
  {
    id: "h25",
    name: "H25",
    power: "25 kW",
    powerNum: 25,
    storage: "24–72 h",
    application: "Small farms / remote facilities",
  },
  {
    id: "h60",
    name: "H60",
    power: "60 kW",
    powerNum: 60,
    storage: "24–168 h",
    application: "Medium farms / commercial applications",
  },
  {
    id: "h125",
    name: "H125",
    power: "125 kW",
    powerNum: 125,
    storage: "24–168 h",
    application: "Dairy / greenhouse",
  },
  {
    id: "h250",
    name: "H250",
    power: "250 kW",
    powerNum: 250,
    storage: "Multi-day",
    application: "Large agricultural microgrids",
  },
];

export const VERTICALS = [
  {
    title: "Dairy Farms",
    detail: "Protect milking, refrigeration, ventilation and pumping loads.",
    image: IMAGES.dairyFields,
  },
  {
    title: "Greenhouses",
    detail: "Support lighting, ventilation, irrigation and other energy-intensive controlled-environment systems.",
    image: IMAGES.greenhouse,
  },
  {
    title: "Cold Storage & Food Processing",
    detail: "Maintain critical refrigeration and processing loads through grid interruptions.",
    image: IMAGES.coldStorage,
  },
  {
    title: "Remote & Grid-Constrained Farms",
    detail: "Reduce diesel dependence and provide autonomous energy reserve where utility capacity is limited.",
    image: IMAGES.silosMountains,
  },
];

export const CUSTOMER_PROBLEMS = [
  {
    n: "01",
    title: "Grid Constraints",
    body: "Rural grid infrastructure may not support new loads, electrification or farm expansion without costly upgrades.",
  },
  {
    n: "02",
    title: "Diesel Dependence",
    body: "Backup generators bring recurring fuel, delivery, maintenance, noise and operating requirements.",
  },
  {
    n: "03",
    title: "Renewable Energy Waste",
    body: "Renewable generation can exceed on-site demand during certain periods, leaving valuable energy underused.",
  },
  {
    n: "04",
    title: "Extended Outages",
    body: "Critical refrigeration, ventilation, pumping and other farm loads may need to remain operational for hours or days.",
  },
  {
    n: "05",
    title: "Extreme Winter",
    body: "Energy infrastructure must be designed for dependable operation through severe Canadian winter conditions.",
  },
];

export const CUSTOMER_BENEFITS = [
  {
    title: "Reduce Diesel Consumption",
    body: "Use renewable generation instead of diesel whenever operating conditions allow.",
  },
  {
    title: "Increase Renewable Self-Consumption",
    body: "Capture and store surplus renewable energy instead of leaving available generation unused.",
  },
  {
    title: "Multi-Day Backup",
    body: "Maintain critical farm operations through prolonged grid interruptions.",
  },
  {
    title: "Support Farm Expansion",
    body: "Reduce dependence on expensive or delayed utility capacity upgrades.",
  },
  {
    title: "Improve Energy Resilience",
    body: "Maintain a local energy reserve when grid power is limited or unavailable.",
  },
];

export const COMPARISON_OPTIONS = ["Grid Upgrades", "Diesel", "Solar + Battery", "Hybrid Microgrid"];

export const COMPARISON_DIMENSIONS = [
  {
    label: "Short-duration response",
    values: ["Utility-dependent", "Immediate, fuel-based", "Strong", "Strong (battery)"],
  },
  {
    label: "Long-duration backup",
    values: ["Not applicable", "Limited by fuel supply", "Limited to hours", "Extended (hydrogen)"],
  },
  {
    label: "Fuel dependence",
    values: ["None", "High", "None", "Low to none, site-dependent"],
  },
  {
    label: "Site infrastructure",
    values: ["Major utility buildout", "Fuel storage & delivery", "Moderate — PV + battery", "Higher upfront complexity"],
  },
  {
    label: "Scalability",
    values: ["Limited by utility capacity", "Scales with additional units", "Scalable, storage duration limited", "Modular, scales with site needs"],
  },
  {
    label: "Renewable utilization",
    values: ["Not applicable", "None", "High, limited by storage duration", "High, extended by hydrogen storage"],
  },
];

export const HERO_PROOF_POINTS = [
  { value: "24–168+ hrs", label: "Backup duration" },
  { value: "–40°C", label: "Design target" },
  { value: "50–250 kW", label: "Modular platform" },
];

export const ECONOMICS_PARAMETERS = [
  { label: "Peak load", value: "150 kW" },
  { label: "Solar", value: "250 kW" },
  { label: "Hydrogen power", value: "60 kW" },
  { label: "Critical-load backup", value: "2–5 days" },
];

export const ECONOMICS_METRICS = [
  "Diesel savings",
  "Demand savings",
  "CAPEX",
  "Annual savings",
  "Payback",
];

export const REGIONS = [
  "Fraser Valley",
  "Okanagan / Interior",
  "Vancouver Island",
  "Cariboo",
  "Peace River",
  "Other BC Region",
];

export const OPERATION_TYPES = [
  "Dairy / Livestock",
  "Poultry",
  "Greenhouse",
  "Orchard / Vineyard",
  "Cold Storage",
  "Other",
];

export const PILOT_QUALIFICATIONS = [
  "Grid constraints",
  "Diesel dependence",
  "Expansion plans",
  "Long-duration backup needs",
];

export const SOLUTIONS = [
  {
    n: "01",
    title: "Off-Grid Power",
    headline: "Reliable power where the grid can't reach",
    body: "For remote agricultural operations where utility infrastructure is unavailable or difficult to extend, a hybrid microgrid can combine on-site renewable generation with battery and hydrogen energy storage to support critical farm loads.",
    icon: "Zap",
  },
  {
    n: "02",
    title: "Diesel Reduction",
    headline: "Use renewable energy before diesel",
    body: "Hybrid systems are designed to reduce dependence on diesel generation by using available renewable energy first and storing surplus generation for later use.",
    supportingLine: "Less reliance on fuel delivery, generator operation and diesel backup.",
    icon: "Fuel",
  },
  {
    n: "03",
    title: "Long-Duration Backup",
    headline: "Backup designed for more than a few hours",
    body: "Batteries provide fast, short-duration response. Hydrogen provides an additional long-duration energy reserve for extended outages and periods of low renewable generation.",
    icon: "Clock",
    stat: { value: "24–168+ hours", label: "Configurable backup duration" },
    disclaimer: "Final backup duration depends on site load, storage configuration and engineering assessment.",
  },
  {
    n: "04",
    title: "Renewable Energy Storage",
    headline: "Store renewable energy instead of wasting it",
    body: "When renewable generation exceeds immediate farm demand, surplus energy can be directed into the hydrogen system for long-duration storage and later converted back into electricity when it is needed.",
    icon: "Database",
  },
  {
    n: "05",
    title: "Farm Microgrids",
    headline: "One integrated energy system",
    body: "Solar PV, site-appropriate wind generation, battery buffering, hydrogen energy storage and energy management controls are coordinated as one hybrid microgrid around the farm's actual load profile and operating requirements.",
    icon: "Cpu",
    link: { label: "See How the Technology Works", to: "/technology" },
  },
];

export const SOLUTIONS_DELIVERY = [
  {
    n: "01",
    title: "Load Assessment",
    body: "Understand site demand, existing energy use, grid constraints and backup requirements.",
  },
  {
    n: "02",
    title: "System Design",
    body: "Develop a site-specific preliminary system configuration based on load and renewable-resource assessment.",
  },
  {
    n: "03",
    title: "Procurement & Integration",
    body: "Coordinate qualified equipment suppliers, controls and licensed contractors.",
  },
  {
    n: "04",
    title: "Installation & Commissioning",
    body: "Manage implementation and commissioning with qualified professionals where required.",
  },
  {
    n: "05",
    title: "Ongoing O&M",
    body: "Support long-term operation through monitoring, performance tracking and scheduled maintenance.",
  },
];

export const APPLICATIONS = [
  {
    n: "01",
    title: "Dairy Farms",
    body: "Dairy operations depend on reliable power across multiple critical systems. Hybrid energy systems can support essential farm loads while reducing dependence on diesel backup and constrained grid infrastructure.",
    tagsLabel: "Typical loads",
    tags: ["Milking systems", "Refrigeration", "Ventilation", "Pumps", "Feed systems"],
    image: IMAGES.dairyFields,
    imageAlt: "Dairy barn interior on a British Columbia farm",
  },
  {
    n: "02",
    title: "Greenhouses",
    body: "Greenhouses can combine high energy demand with strong seasonal variation. A site-specific hybrid system can help manage renewable generation, short-duration fluctuations and longer backup requirements.",
    tagsLabel: "Typical loads",
    tags: ["Lighting", "Heating systems", "Ventilation", "Irrigation"],
    image: IMAGES.greenhouse,
    imageAlt: "Greenhouse rows under controlled-environment lighting",
  },
  {
    n: "03",
    title: "Cold Storage",
    body: "Cold-storage operations require dependable power to maintain refrigeration and protect temperature-sensitive agricultural products during grid interruptions.",
    tagsLabel: "Primary need",
    tags: ["Uninterrupted refrigeration"],
    image: IMAGES.coldStorage,
    imageAlt: "Cold storage and food processing facility",
  },
  {
    n: "04",
    title: "Grain & Food Processing",
    body: "Agricultural processing facilities can experience significant seasonal energy demand and require reliable power for critical production and storage operations.",
    tagsLabel: "Primary need",
    tags: ["High seasonal energy requirements"],
    image: IMAGES.grainProcessing,
    imageAlt: "Grain processing facility with conveyor systems and storage silos",
  },
  {
    n: "05",
    title: "Remote & Grid-Constrained Farms",
    body: "Where utility infrastructure is limited, expensive to expand or unavailable, hybrid renewable systems can reduce diesel dependence and provide a local source of resilient power.",
    tagsLabel: "Primary needs",
    tags: ["Diesel displacement", "Autonomous power", "Reduced dependence on grid expansion"],
    image: IMAGES.silosMountains,
    imageAlt: "Grain silos in a remote mountain valley",
  },
  {
    n: "06",
    title: "Emergency Farm Backup",
    body: "For agricultural operations where outages can interrupt critical equipment, long-duration energy storage can help maintain essential loads beyond the short backup periods typically served by batteries alone.",
    tagsLabel: "Primary need",
    tags: ["Multi-day critical-load protection"],
    image: IMAGES.irrigationPumpStation,
    imageAlt: "Agricultural pumping station with backup power control panels at sunset",
  },
];

export const PRODUCT_FAMILY = [
  {
    model: "H25",
    power: "25 kW",
    storage: "Indicative backup duration: 24–72 h",
    application: "Small farms / remote facilities",
    scale: 30,
  },
  {
    model: "H60",
    power: "60 kW",
    storage: "Indicative backup duration: 24–168 h",
    application: "Medium farms / commercial applications",
    scale: 52,
  },
  {
    model: "H125",
    power: "125 kW",
    storage: "Indicative backup duration: 24–168 h",
    application: "Dairy / greenhouse / large agricultural facilities",
    scale: 75,
  },
  {
    model: "H250",
    power: "250 kW",
    storage: "Indicative backup duration: Multi-day",
    application: "Large / multi-building microgrids",
    scale: 100,
  },
];

export const PLATFORM_PRINCIPLES = [
  "Defined power classes",
  "Configurable storage duration",
  "Standardized EMS & communications",
  "Site-specific system integration",
];

export const PLATFORM_COMPARISON = {
  standardized: {
    title: "Standardized Platform",
    intro: "A repeatable foundation across the H-series.",
    items: [
      "Power-class architecture",
      "Energy-management approach",
      "Controls & communications",
      "System integration framework",
    ],
  },
  configured: {
    title: "Configured For Each Site",
    intro: "Sized around actual operating requirements.",
    items: [
      "Solar and wind capacity",
      "Battery buffering",
      "Hydrogen storage duration",
      "Critical-load requirements",
    ],
  },
};

export const PRODUCTS_PROCESS = [
  {
    n: "01",
    title: "Assess the Load",
    body: "Review peak demand, energy use, operating patterns and critical loads.",
  },
  {
    n: "02",
    title: "Select the Power Class",
    body: "Identify the H-series reference class based on preliminary power requirements.",
  },
  {
    n: "03",
    title: "Configure Generation & Storage",
    body: "Size renewable generation, battery buffering and hydrogen storage for the site.",
  },
  {
    n: "04",
    title: "Engineer & Integrate",
    body: "Coordinate equipment, controls, qualified contractors, installation and commissioning.",
  },
];

export const HYDROGEN_LOOP_STAGES = [
  {
    title: "Electrolyzer",
    body: "Converts surplus electricity into hydrogen.",
  },
  {
    title: "Hydrogen Storage",
    body: "Stores hydrogen for later use.",
  },
  {
    title: "Fuel Cell",
    body: "Converts stored hydrogen into electricity.",
  },
];

export const EMS_FUNCTIONS = [
  { title: "Monitor", body: "Track generation, storage and load conditions." },
  { title: "Coordinate", body: "Direct energy between generation, storage and farm loads." },
  { title: "Support", body: "Help maintain the required energy balance as conditions change." },
];

export const KEY_INTEGRATION_AREAS = [
  "Renewable generation & storage sizing",
  "Controls & communications",
  "Site-specific engineering",
  "Commissioning & ongoing O&M",
];

export const SAFETY_AREAS = [
  {
    title: "Engineering",
    body: "Project documentation and regulated engineering activities will be prepared or supervised by appropriately licensed British Columbia professionals where required.",
  },
  {
    title: "Equipment",
    body: "Projects will use qualified suppliers and appropriately certified equipment based on the requirements of the final system design.",
  },
  {
    title: "Regulatory Pathway",
    body: "Applicable requirements may include Technical Safety BC, EGBC, WorkSafeBC, Transport Canada and municipal or regional authorities.",
  },
  {
    title: "Commissioning",
    body: "Final installations will follow the applicable professional review, inspection, acceptance and commissioning requirements.",
  },
];

export const EXPERIENCE_CHAPTERS = [
  {
    title: "ENGINEERING",
    body: "Mechanical engineering, process engineering and R&D.",
  },
  {
    title: "MANUFACTURING",
    body: "Quality, production and industrial operations leadership.",
  },
  {
    title: "OEM & SOURCING",
    body: "Global sourcing and project coordination.",
  },
  {
    title: "INDUSTRIAL INTEGRATION",
    body: "Project delivery and industrial equipment integration.",
  },
];

export const HOW_WE_WORK_STEPS = [
  { title: "Assess", body: "Understand loads, site conditions and energy requirements." },
  { title: "Design", body: "Develop the site-specific system configuration." },
  { title: "Coordinate", body: "Bring together qualified suppliers, professionals and contractors." },
  { title: "Deliver", body: "Manage integration, installation coordination and commissioning." },
  { title: "Support", body: "Monitoring, performance tracking and ongoing O&M." },
];

export const FOUNDER_MARKERS = [
  { stat: "30+ years", label: "Engineering & industrial experience" },
  { stat: "China + North America", label: "International operating experience" },
  { stat: "Engineering + Leadership", label: "Technical & management experience" },
];

export const COST_COMPARISON = {
  current: {
    title: "Current Approach",
    subtitle: "Grid + Diesel",
    items: [
      "Electricity & demand charges",
      "Diesel & fuel delivery",
      "Generator maintenance",
      "Potential grid-extension costs",
      "Outage-related exposure",
    ],
  },
  hybrid: {
    title: "Hybrid Approach",
    subtitle: "Solar + Battery + Hydrogen",
    items: [
      "Initial system investment",
      "Renewable generation",
      "Storage & integration",
      "Operating & maintenance costs",
      "Equipment servicing & replacement",
    ],
  },
};

export const ASSESSMENT_FACTORS = [
  { n: "01", title: "Diesel Savings", body: "Potential reduction in diesel-related costs." },
  { n: "02", title: "Demand Savings", body: "Potential reduction in peak-demand charges." },
  { n: "03", title: "Renewable Utilization", body: "Renewable energy used or stored." },
  { n: "04", title: "CAPEX", body: "Estimated upfront system investment." },
  { n: "05", title: "Annual Savings", body: "Estimated annual operating-cost difference." },
  { n: "06", title: "Payback", body: "Estimated investment recovery period." },
  { n: "07", title: "Lifecycle Cost", body: "Total cost across the system lifecycle." },
];

export const SITE_SPECIFIC_FACTORS = [
  "Annual electricity consumption",
  "Peak electrical demand",
  "Diesel consumption",
  "Existing renewable capacity",
  "Required backup duration",
];

export const PILOT_SUITABILITY_CRITERIA = [
  {
    n: "01",
    title: "British Columbia Location",
    body: "An agricultural operation located in BC.",
  },
  {
    n: "02",
    title: "Grid Limitations",
    body: "Limited grid capacity, expensive connection or extension requirements.",
  },
  {
    n: "03",
    title: "Diesel Dependence",
    body: "Existing diesel generation or significant fuel consumption.",
  },
  {
    n: "04",
    title: "Backup Requirements",
    body: "Critical agricultural loads requiring reliable power during extended outages.",
  },
  {
    n: "05",
    title: "Renewable Energy Interest",
    body: "Existing solar generation or interest in integrating renewable energy.",
  },
  {
    n: "06",
    title: "Expansion Plans",
    body: "Future increases in electricity demand or facility capacity.",
  },
];

export const PILOT_OBJECTIVES = [
  {
    title: "Energy Profile",
    body: "Understand the farm's electricity demand, peak loads and existing energy infrastructure.",
  },
  {
    title: "Renewable Integration",
    body: "Evaluate opportunities to combine available renewable generation with energy storage.",
  },
  {
    title: "Backup Requirements",
    body: "Explore the storage configuration needed to support critical loads during extended outages.",
  },
  {
    title: "Economic Feasibility",
    body: "Compare the proposed approach with relevant existing energy alternatives, including grid and diesel where applicable.",
  },
];

export const PILOT_PROCESS_STEPS = [
  {
    n: "01",
    title: "Submit Your Interest",
    body: "Share basic information about your operation and energy requirements.",
  },
  {
    n: "02",
    title: "Initial Site Screening",
    body: "Review the submitted information and identify whether further assessment may be appropriate.",
  },
  {
    n: "03",
    title: "Feasibility Review",
    body: "Where suitable, explore preliminary system configuration, engineering requirements and potential project economics.",
  },
  {
    n: "04",
    title: "Project Discussion",
    body: "Discuss next steps, responsibilities and commercial terms before making a project commitment.",
  },
];

